<template>
  <div>
    <ul :class="display" class="unstyled-list">
      <li v-for="result in results" :key="result.Name">
        <CatalogProduct :result="result" :catalog="catalog" />
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import { FETCH_RESULTS } from '../vuex/modules/global-search/mutations';
import CatalogProduct from './CatalogProduct.vue';

export default {
  name: 'SearchResults',
  components: {
    CatalogProduct,
  },

  data() {
    return {
      // display: 'list',
    }
  },
  mounted() {
    this.getInitialResults();
  },
  methods: {
    ...mapActions({
      FETCH_RESULTS,
    }),

    getInitialResults() {
      this.FETCH_RESULTS();
    },
  },

  computed: {
    ...mapState({
      results: state => state.gobalSearch.results,
    }),
  }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/SearchResults.vue